import isElem from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	bg: '.js-full-bg-img'
};

const fullBgImage = () => {
	const image = $(selectors.bg);
	const img = new Image();
	img.src = image.data('src');
	img.onload = () => {
		image.css('background-image', 'url(' + img.src + ')');
		image.addClass('is-load');
	};
};

const render = () => {
	if (isElem(selectors.bg)) {
		fullBgImage();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/full-bg-img/full-bg-img.js